import ReactDOM from 'react-dom';

export default class HelperUtils {

  static scrollToAlert(alertRef) {
    if (alertRef) {
      const dom = ReactDOM.findDOMNode(alertRef.current);
      dom.scrollIntoView();
    }
  }

  static scrollToDomRef(domRef) {
    if (domRef) {
      domRef.current.scrollIntoView();
    }
  }

  //https://gist.github.com/slavikshen/7b29b06215b9e7a08455
  static getInnerText(obj) {
    let buf = '';
    if( obj ) {
      let type = typeof(obj);
      if( type === 'string' || type === 'number' ) {
        buf += obj;
      } else if( type === 'object' ) {
        let children = null;
        if( Array.isArray(obj) ) {
          children = obj;
        } else {
          let props = obj.props;
          if( props ) {
            children = props.children;
          }
        }
        if( children ) {
          if( Array.isArray(children) ) {
            children.forEach(function(o) {
              buf += HelperUtils.getInnerText(o);
            });
          } else {
            buf += HelperUtils.getInnerText(children);
          }
        }
      }
    }
    return buf;
  };

  static styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
}